"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Palette_1 = require("../model/Palette");
const Pixels_1 = require("../model/Pixels");
class Quantizer {
    constructor(palette, colorspace) {
        this.distance = (realPixel, paletteIndex) => {
            const realPixelConverted = this.colorspace(realPixel);
            const palettePixel = this.palette.colors[paletteIndex];
            return Math.sqrt((realPixelConverted[0] - palettePixel[0]) ** 2 +
                (realPixelConverted[1] - palettePixel[1]) ** 2 +
                (realPixelConverted[2] - palettePixel[2]) ** 2);
        };
        this.colorspace = colorspace;
        this.palette = new Palette_1.default(palette.colors.map(p => colorspace(p)));
        this.palette.enabled = palette.enabled;
    }
    quantizePixel(pixel) {
        return this.palette.enabled
            .map(index => [index, this.distance(pixel, index)])
            .reduce((acc, current) => (current[1] < acc[1] ? current : acc), [null, Number.POSITIVE_INFINITY])[0];
    }
    quantizeImage(image) {
        const result = [];
        for (let y = 0; y < image.height; y++) {
            for (let x = 0; x < image.width; x++) {
                result.push(this.quantizePixel(Pixels_1.default.peek(image, x, y)));
            }
        }
        return result;
    }
}
exports.default = Quantizer;
//# sourceMappingURL=Quantizer.js.map